<template>
  <div class="font-size-h3 text-default text-center">
    <span>
    {{ paymentMessage }}
    </span>
    <span class="font-weight-bold">
      {{ formattedStartDay }}, {{ formattedStartDate }} at {{ formattedStartTime }}.
    </span>
    <span>
      {{ statusMessage }}
    </span>
  </div>

</template>

<script>
import { BookingPaymentDateTimeMixin } from '@/mixins/BookingPayment/BookingPaymentDateTimeMixin'

export default {
  name: 'PaymentRequired',
  mixins: [BookingPaymentDateTimeMixin],
  props: {
    bookingStatus: Object,
    paymentStatus: Object
  },
  computed: {
    statusMessage () {
      switch (this.bookingStatus?.id) {
        case 1: // booked / under review
          return 'Your request is currently under review. An email indicating this will be sent shortly.'
        case 2: // approved
          return 'Your request has been approved. A confirmation email will be sent shortly.'
        case 3: // declined
          return 'Your request was declined.'
        case 4: // expired
          return 'Your request has expired.'
        case 0: // unknown
        default:
          return 'The status of your request is not available at the moment. Please check your email for updates.'
      }
    },
    paymentMessage () {
      switch (this.paymentStatus?.id) {
        case 4: // paid
          return 'Thank you for paying your booking request for'
        case 3: // outstanding / failed
          return 'Payment failed for your booking request for'
        default:
          return 'Payment status is unavailable for your booking request for'
      }
    }
  }
}
</script>
